<template>
  <div class="modal">
    <div class="container container--small">
      <div class="modal__controls">
        <button
          class="modal__close"
          type="button"
          aria-label="schließen"
          title="schließen"
          @click="$emit('close')"
        >
          <Icon id="x" />
        </button>
      </div>

      <div class="modal__content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Icon.vue';

export default {
  components: {
    Icon,
  },
};
</script>

<style scoped lang="scss">
.modal {
  background-color: $color-white;
  padding: $container-padding 0;
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: map-get($z-index, modal);
  animation: fadeIn map-get($animation-speed, fast) ease-out;
  -webkit-overflow-scrolling: touch; // Smooth iOS like scrolling

  &__controls {
    padding-bottom: $container-padding;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  &__close {
    @include resetButtonStyle;
    color: $color-primary;
  }

  &__content {
    animation: fadeMoveUp map-get($animation-speed, fast) ease-out;
  }
}
</style>
